import { privateMediaPath, isTransientMediaError } from 'dashboard/helpers/authenticatedMedia.mjs';
import { acquireMedia, sameOriginMedia } from 'dashboard/helpers/mediaResource';
const slots = new WeakMap();

function dispose(el) {
  const old = slots.get(el);
  if (!old) return;
  old.live = false;
  old.lease?.release();
  el.removeEventListener('error', old.error);
  window.removeEventListener('online', old.online);
  slots.delete(el);
}
function update(el, binding) {
  if (binding.value === binding.oldValue && slots.has(el)) return;
  dispose(el);
  el.removeAttribute('src');
  const source = binding.value;
  const state = { live: true, retried: false, transient: false, loading: false };
  slots.set(el, state);
  async function load() {
    if (!state.live || state.loading) return;
    state.loading = true;
    const old = state.lease;
    state.lease = acquireMedia(source);
    try {
      const url = await state.lease.promise;
      state.transient = false;
      if (state.live) el.src = url;
    } catch (error) {
      state.transient = isTransientMediaError(error);
      if (state.live) el.dispatchEvent(new Event('error'));
    } finally { old?.release(); state.loading = false; }
  }
  state.error = () => {
    if (!state.loading && !state.retried && sameOriginMedia(source) && !el.src.startsWith('blob:')) {
      state.retried = true;
      load();
    }
  };
  state.online = () => { if (state.transient) load(); };
  el.addEventListener('error', state.error);
  window.addEventListener('online', state.online);
  if (!source) return;
  if (privateMediaPath(source, window.location.origin)) load();
  else el.src = source;
}
export const vPrivateSrc = { mounted: update, updated: update, beforeUnmount: dispose };
